import { cx } from '@emotion/css';
type Size = 'xs' | 'small' | 'medium' | 'large';

const Signal = ({ size = 'large', className }: { size?: Size; className?: string }) => (
  <div className={cx(`signal ${size}`, className)} />
);

export default Signal;
